var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenBerachain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.097 10.429C19.0849 10.3515 19.0638 10.2756 19.034 10.203C19.045 10.186 21.494 7.01401 19.226 5.05301C16.962 3.09301 14.318 5.65001 14.303 5.66301C13.8904 5.54239 13.4665 5.46432 13.038 5.43001H13.034C12.171 5.29701 10.962 5.43001 10.962 5.43001C10.5374 5.46475 10.1173 5.5418 9.708 5.66001C9.693 5.64601 7.049 3.08901 4.785 5.05001C2.521 7.01001 4.965 10.186 4.977 10.2C4.95033 10.2747 4.92933 10.35 4.914 10.426C4.67 11.783 3 12.2 3 14.567C3 16.977 4.744 18.877 8.307 18.877H9.767C9.774 18.883 10.339 19.631 11.504 19.675C11.504 19.675 11.774 19.703 12.393 19.682C13.628 19.682 14.229 18.89 14.233 18.88H15.693C19.256 18.88 21 16.98 21 14.57C21.011 12.208 19.34 11.787 19.097 10.429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenBerachain);
export default __webpack_public_path__ + "static/media/token_berachain.e7ae542ad2ccf07200b1918f3a5ce879.svg";
export { ForwardRef as ReactComponent };